import { render } from "./AyudaMedioPersForm.vue?vue&type=template&id=400013c9&scoped=true"
import script from "./AyudaMedioPersForm.vue?vue&type=script&lang=js"
export * from "./AyudaMedioPersForm.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=400013c9&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400013c9"]])

export default __exports__